import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  setUpdateCardFlag,
  getUpdatePaymentSettingsFlag,
} from 'ducks/trialWarning'
import { isCurrentPlanType } from 'utils/billing.ts'

import { PaymentForm as SharedPaymentForm } from 'components/Shared/PaymentForm'
import OldPaymentForm from './OldPaymentForm'

export const PaymentMethodForm = ({ selectedPlanValue, subscription }) => {
  const dispatch = useDispatch()
  const isPaymentMethodUpdateOnly = useSelector(getUpdatePaymentSettingsFlag)
  const updateCardFlagTrue = () => dispatch(setUpdateCardFlag(true))

  const showNewPlansPaymentForm =
    isCurrentPlanType(selectedPlanValue) && !isPaymentMethodUpdateOnly

  return showNewPlansPaymentForm ? (
    <div className="billing-payment-form">
      <SharedPaymentForm
        formName="trialModalSignup"
        includeAddress
        includeSavePaymentToggle={false}
        updateCardFlagTrue={updateCardFlagTrue}
      />
    </div>
  ) : (
    <OldPaymentForm
      subscription={subscription}
      updatePaymentSettings={isPaymentMethodUpdateOnly}
      updateCardFlagTrue={updateCardFlagTrue}
    />
  )
}
